// src/layouts/AppLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { ShowIfLoggedInAndVerified } from '../features/auth/auth_utils';

export default function AppLayout({filters, onChange}) {
  return (
    <ShowIfLoggedInAndVerified>
      <TopNavbar />
      <div className="d-sm-flex mt-1">
        <Sidebar filters={filters} onChange={onChange}/>
        <div className="content mt-0 mb-0 me-0">
          <Outlet />
        </div>
      </div>
    </ShowIfLoggedInAndVerified>
  );
}
